import PageShell from '../components/PageShell';
import SEO from '../components/SEO';
import Contact from '../components/Contact';
import { useI18n } from '../contexts/I18nContext';

export default function ContactPage() {
  const { t } = useI18n();
  return (
    <PageShell
      eyebrow={t('contact.eyebrow')}
      title={<>{t('contact.title1')} {t('contact.title2')} <span className="italic text-[#E5614C]">{t('contact.title3')}</span></>}
      subtitle={t('contact.subtitle')}
      accent="coral"
    >
      <SEO
        title="Contact Us"
        description="Get in touch with GEMS @ The Arts in Framingham, MA. Visit us at 160 Hollis Street, call (508) 405-2787, or email info@gemsatthearts.org. We&rsquo;d love to hear from you."
        path="/contact"
      />
      {/* Reuses the shared Contact section so styling stays consistent with the homepage */}
      <Contact />
    </PageShell>
  );
}
